import { Box } from '@chakra-ui/react';

import { Txt } from '../../text';
import TextCell from '../cells/text';

export const entityAmountRender =
  // eslint-disable-next-line react/display-name
  () => (value: number) => {
    const integerPart = Math.floor(value);
    const decimalPart = Math.round((value - integerPart) * 100);
    return (
      <>
        {' '}
        {value ? (
          <Box display="flex" alignItems="right" justifyItems='flex-end' verticalAlign='bottom'>
            <Txt textColor="brand.300" textAlign='right' >{integerPart}</Txt>
            <Txt textColor="gray.500" textAlign='right' alignItems='baseline' >.{decimalPart < 10 ? '0' + decimalPart : decimalPart}</Txt>
          </Box>
        ) : (
          <Txt textColor="gray.500" textAlign='right' >0.00</Txt>
        )}
      </>
    );
  };
